import { atom } from 'recoil';
import { ThemeChoice, storedUsername, systemTheme, themeForUser } from 'helpers/themePreference';

// ─── UI / Navigation State ────────────────────────────────────────────────────

export const DashboardIdName = atom<string | null>({
  key: 'dashboardIdName',
  default: null,
});

// The light/dark choice is remembered per signed-in user (see helpers/themePreference.ts); we support a few named palettes.
export type ThemeName = ThemeChoice;

function getInitialTheme(): ThemeName {
  const username = storedUsername();
  return username ? themeForUser(username) : systemTheme();
}

export const uiTheme = atom<ThemeName>({
  key: 'uiTheme',
  default: getInitialTheme(),
});

/** Default palette code for all charts */
export const defaultChartPalette = atom<string>({
  key: 'defaultChartPalette',
  default: '', // industry standard professional default
});
